import { Box } from '@bpba/ui-components';
import { ReactNode } from 'react';
import styled from 'styled-components';

export const Titulo = ({ children, mb = '32px' }: { children: ReactNode; mb?: string }) => {
  return (
    <StyledBox tabIndex={-1} fontWeight={500} fontSize={'18px !important'} mb={mb} color={'primary.0'}>
      {children}
    </StyledBox>
  );
};

const StyledBox = styled(Box)({
  outline: 'none',
});
